import { createRoot } from "react-dom/client";
import React from "react";
import styles from "./CustomToast.module.less";

// 简化的Toast组件
const CustomToastComponent = ({ message, onClose }) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      onClose?.();
    }, 3000); // 3秒后自动关闭

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={styles["custom-toast"]}>
      <div className={styles["custom-toast-content"]}>{message}</div>
    </div>
  );
};

// 显示Toast的函数
export const showCustomToast = (message) => {
  if (!message) return;

  const toastId = "custom-toast-container";

  // 移除已存在的Toast
  const existingToast = document.getElementById(toastId);
  if (existingToast) {
    try {
      document.body.removeChild(existingToast);
    } catch (error) {
      console.warn("Failed to remove existing toast:", error);
    }
  }

  // 创建新的Toast容器
  const toastDiv = document.createElement("div");
  toastDiv.id = toastId;
  document.body.appendChild(toastDiv);
  const root = createRoot(toastDiv);

  const destroyToast = () => {
    try {
      root.unmount();
    } catch (error) {
      console.warn("Failed to unmount toast root:", error);
    }

    try {
      if (document.body.contains(toastDiv)) {
        document.body.removeChild(toastDiv);
      }
    } catch (error) {
      console.warn("Failed to remove toast div:", error);
    }
  };

  // 渲染Toast
  root.render(
    <CustomToastComponent message={message} onClose={destroyToast} />
  );

  // 自动销毁
  setTimeout(() => {
    destroyToast();
  }, 3000);

  return destroyToast;
};
